<template>
    <div>
        <!-- BEGIN HEADER -->
        <div class="page-header navbar navbar-fixed-top">
            <!-- BEGIN HEADER INNER -->
            <div class="page-header-inner ">

                <!-- BEGIN LOGO -->
                <div class="page-logo">
                    <router-link :to="{name: 'start.index'}">
                        <img src="https://s3.amazonaws.com/tab-assets/logo_mcenter.svg" alt="logo" class="logo-default"/>
                    </router-link>
                    <div class="menu-toggler sidebar-toggler" @click="toggleSidebar()">
                        <span></span>
                    </div>
                </div>
                <!-- END LOGO -->

                <!-- BEGIN RESPONSIVE MENU TOGGLER -->
                <a href="javascript:;" class="menu-toggler responsive-toggler" @click="toggleSidebar()">
                    <span></span>
                </a>
                <!-- END RESPONSIVE MENU TOGGLER -->

                <!-- BEGIN TOP NAVIGATION MENU -->
                <div class="top-menu">
                    <ul class="nav navbar-nav pull-right">
                        <!--<v-notification @toggle="toggleDropdown($event, 'notification')"-->
                        <!--v-click-outside="hideDropdowns"-->
                        <!--:isOpen="activeDropdown == 'notification'"></v-notification>-->
                        <!--<v-inbox @toggle="toggleDropdown($event, 'inbox')"-->
                        <!--v-click-outside="hideDropdowns"-->
                        <!--:isOpen="activeDropdown == 'inbox'"></v-inbox>-->
                        <!--<v-todo @toggle="toggleDropdown($event, 'todo')"-->
                        <!--v-click-outside="hideDropdowns"-->
                        <!--:isOpen="activeDropdown == 'todo'"></v-todo>-->
                        <v-lang-switcher @toggle="toggleDropdown($event, 'langSwitcher')"
                                         v-click-outside="hideDropdowns"
                                         :isOpen="activeDropdown == 'langSwitcher'"></v-lang-switcher>
                        <v-user-login @toggle="toggleDropdown($event, 'login')"
                                      v-click-outside="hideDropdowns"
                                      :isOpen="activeDropdown == 'login'"></v-user-login>

                        <!-- BEGIN QUICK SIDEBAR TOGGLER -->
                        <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown style -->
                        <!-- <li class="dropdown">
                           <a v-if="!$auth.state.authenticated" href="#" class="dropdown-toggle" @click.prevent="$auth.login()">
                             <i class="icon-login"></i>
                           </a>
                           <a v-if="$auth.state.authenticated" href="#" class="dropdown-toggle" @click.prevent="$auth.logout()">
                             <i class="icon-logout"></i>
                           </a>
                         </li>-->
                        <!-- END QUICK SIDEBAR TOGGLER -->
                    </ul>
                </div>
                <!-- END TOP NAVIGATION MENU -->
            </div>
            <!-- END HEADER INNER -->
        </div>
        <!-- END HEADER -->
        <!-- BEGIN HEADER & CONTENT DIVIDER -->
        <div class="clearfix"></div>
        <!-- END HEADER & CONTENT DIVIDER -->
    </div>
</template>

<script>
  import VNotification from './Notification'
  import VInbox from './Inbox'
  import VTodo from './Todo'
  import VLangSwitcher from './LangSwitcher'
  import VUserLogin from './UserLogin'

  export default {
    components: {
      VNotification,
      VInbox,
      VTodo,
      VLangSwitcher,
      VUserLogin
    },
    data () {
      return {
        activeDropdown: null
      }
    },
    methods: {
      toggleSidebar () {
        this.$emit('toggleSidebar')
      },
      toggleDropdown (event, dropdownName) {
        this.activeDropdown = event.isOpen ? dropdownName : null
      },
      hideDropdowns () {
        this.activeDropdown = null
      }
    }
  }
</script>

<style lang="scss">
    .dropdown {
        > ul.dropdown-menu {
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/components/header/Header.vue